import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Check } from "lucide-react";
import { api } from "@/lib/api";
import QuoteForm from "@/components/site/QuoteForm";
import FAQ from "@/components/site/FAQ";

const IMAGES = {
  "renovation-complete": "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/bef13f1daac35a77b0153bac43c927e36792ce732857819bd0c65d07f4fbcaf3.png",
  "renovation-cuisine": "https://images.pexels.com/photos/29412579/pexels-photo-29412579.jpeg",
  "renovation-salle-de-bain": "https://images.pexels.com/photos/34787744/pexels-photo-34787744.jpeg",
  "peinture-decoration": "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/ec81571e1805db7f10ea0b003663abee06a6d7bd6c67c1bec0309500e16f7218.png",
  "electricite": "https://images.pexels.com/photos/28536630/pexels-photo-28536630.jpeg",
  "plomberie": "https://images.pexels.com/photos/19786084/pexels-photo-19786084.jpeg",
};

export default function ServicePage() {
  const { slug } = useParams();
  const [service, setService] = useState(null);

  useEffect(() => {
    api.get(`/services/${slug}`).then((r) => setService(r.data)).catch(() => setService(null));
    document.title = `${slug.replace(/-/g, " ")} — MAISON FAUBOURG`;
  }, [slug]);

  if (!service) return <div className="container-max pt-40 pb-20 font-display text-3xl">Chargement…</div>;

  return (
    <div data-testid="service-page" className="pt-32 bg-bone">
      <section className="container-max">
        <Link to="/" className="overline link-arc inline-flex items-center gap-2 mb-12">
          <ArrowLeft className="w-3 h-3" /> Retour
        </Link>
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 md:col-span-7">
            <p className="overline">— Service</p>
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9 }}
              className="font-display font-light text-5xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tighter mt-4"
            >
              {service.title}
            </motion.h1>
            <p className="mt-6 font-display italic text-2xl md:text-3xl text-terracotta">{service.tagline}</p>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-ink/75 text-lg leading-relaxed">{service.description}</p>
          </div>
        </div>
      </section>

      <section className="mt-20">
        <div className="container-max">
          <img src={IMAGES[service.slug]} alt={service.title} className="w-full aspect-[16/8] object-cover" />
        </div>
      </section>

      <section className="section">
        <div className="container-max grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <p className="overline">— Notre engagement</p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 className="font-display font-light text-4xl md:text-6xl leading-tight tracking-tight">
              Ce que comprend la prestation.
            </h2>
            <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
              {service.bullets.map((b) => (
                <li key={b} className="flex gap-3 items-start border-t border-ink/15 pt-4">
                  <Check className="w-5 h-5 text-terracotta mt-0.5" />
                  <span className="text-ink/85 text-lg">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <QuoteForm />
      <FAQ />
    </div>
  );
}
